export default "__VITE_ASSET__rVziMsk9__"